import { useState } from 'react';
import { Check, Copy } from 'lucide-react';

/** sha256 do PDF guardado (valor da API, sem transformacao) com botao de copiar. */
export function ShaCopiavel({ valor }: { valor: string }) {
  const [copiado, setCopiado] = useState(false);

  async function copiar() {
    try {
      await navigator.clipboard.writeText(valor);
      setCopiado(true);
    } catch {
      setCopiado(false);
    }
  }

  return (
    <span className="flex flex-wrap items-center gap-2">
      <code data-testid="sha256-pdf" className="tabular break-all rounded-md bg-surface-muted px-2 py-1 text-micro text-ink-body">
        {valor}
      </code>
      <button
        type="button"
        onClick={() => void copiar()}
        aria-label="Copiar sha256 do PDF"
        className="inline-flex h-7 items-center gap-1 rounded-md border border-border bg-card px-2 text-caption font-medium hover:bg-line-soft"
      >
        {copiado ? <Check aria-hidden="true" className="size-3.5" /> : <Copy aria-hidden="true" className="size-3.5" />}
        {copiado ? 'Copiado' : 'Copiar'}
      </button>
    </span>
  );
}
